import { ReactNode } from 'react';

import { CustomerWithExtraData } from '~src/context/CustomerContext';
import { useLeadOrigin } from '~src/hooks/useLeadOrigin';

import { useGdprConsent } from './useGdprConsent';

type CustomerInformationProps = {
  customer?: Partial<CustomerWithExtraData>;
  setCustomer?: (value?: Partial<CustomerWithExtraData>) => void;
};

export const useSwitchEntries = ({ customer, setCustomer }: CustomerInformationProps) => {
  const { origin } = useLeadOrigin();
  const consent = useGdprConsent();

  const updateState = (input: Partial<CustomerWithExtraData>) => setCustomer?.({ ...customer, ...input });

  const { jyskeBankDataConsent: customerJyskeBankDataConsent } = customer ?? {};

  const entries: { label: ReactNode; key: string; value?: boolean; onChange: (value: boolean) => void }[] = [
    ...(origin === 'jyskebank'
      ? [
          {
            label: consent,
            value: customerJyskeBankDataConsent ?? false,
            key: 'jyskeBankDataConsent',
            onChange: (jyskeBankDataConsent: boolean) => updateState({ jyskeBankDataConsent }),
          },
        ]
      : []),
  ];

  return entries;
};
